<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-text-field
                    v-model.lazy="search"
                    append-icon="mdi-magnify"
                    label="Cautare..."
                    single-line
                    hide-details
                ></v-text-field>
                <v-btn
                    color="primary"
                    dark
                    class="ml-2"
                    @click="addNewItem"
                >
                    Adaugare
                </v-btn>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            :expanded.sync="expanded"
            :single-expand="true"
            show-expand
            class="elevation-1"
        >
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.supplier_id="{ item }">
                {{ _.get(item.supplier, 'name', 'Nedefinit') }}
            </template>
            <template v-slot:item.document_date="{ item }">
                {{ new Date(item.document_date) | date }}
            </template>
            <template v-slot:item.vehicle_id="{ item }">
                {{ _.get(item.object, 'vehicle_plate', 'Nedefinit') }}
            </template>
            <template v-slot:item.mileage="{ item }">
                {{ item.mileage | number }} KM
            </template>
            <template v-slot:item.id="{ item }">
                {{ _.get(item, 'items.0.qty', 'Nedefinit') | number }} L
            </template>
            <template v-slot:item.amount_with_vat="{ item }">
                {{ item.amount_with_vat | price }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="px-2 py-2">
                <v-simple-table class="elevation-20">
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <td width="30%">Data platii</td>
                            <td width="30%">Numar document</td>
                            <td width="15%">Valoare</td>
                            <td width="15%">Metoda de plata</td>
                            <td width="10%">
                                <v-btn small color="success" @click="openPaymentDialog(expanded)">
                                    Adauga plata
                                </v-btn>
                            </td>
                        </tr>
                        </thead>
                        <tbody v-if="_.get(expanded, '0.payments', []).length">
                        <tr v-for="(payment, paymentIndex) in expanded[0].payments" :key="paymentIndex">
                            <td>{{ new Date(payment.payment_date) | date }}</td>
                            <td>{{ payment.document_no }}</td>
                            <td>{{ payment.amount | price }}</td>
                            <td>{{ _.get(generalPaymentTypes, payment.method, 'Nedefinit') }}</td>
                            <td>
                                <v-icon small class="mr-2" @click="openPaymentDialog(expanded, payment)">
                                    mdi-pencil
                                </v-icon>
                                <v-icon
                                    small
                                    @click="openPaymentDeleteDialog(item, payment)"
                                >
                                    mdi-delete
                                </v-icon>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="5">
                                <v-alert dense type="info">
                                    Nu sunt plati inregistrate pentru acest document.
                                </v-alert>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </td>
        </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <payment-dialog v-if="paymentDialog" :dialog="paymentDialog" :payment="payment" :expense="expanded[0]" @close="closePaymentDialog"></payment-dialog>
        <payment-delete-dialog v-if="paymentDeleteDialog" :dialog="paymentDeleteDialog" :payment="payment" :expense="expanded[0]" @close="closePaymentDeleteDialog"></payment-delete-dialog>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import PaymentDialog from "Components/common/PaymentDialog";
    import PaymentDeleteDialog from "Components/common/PaymentDeleteDialog";
    export default {
        extends: SmartTable,
        components: {
            PaymentDialog,
            PaymentDeleteDialog
        },
        data: () => ({
            title: 'Alimentari auto',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Furnizor', value: 'supplier_id' },
                { text: 'Data', value: 'document_date' },
                { text: 'Vehicul', value: 'vehicle_id' },
                { text: 'Rulaj', value: 'mileage' },
                { text: 'Cantitate', value: 'id', sortable: false },
                { text: 'Valoare', value: 'amount_with_vat' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            options: {
                sortBy: ['document_date'],
                sortDesc: [true]
            },
            expanded: undefined,
            paymentDialog: false,
            paymentDeleteDialog: false,
            payment: undefined
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                let { data, meta } = await this.$db.Expense
                    .orderBy(this.orderBy)
                    .where('fuel', true)
                    .include('supplier', 'object', 'items', 'payments')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .get()
                this.items = data
                this.meta = meta
            },


            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Expense) {
                    await item.delete()
                }
                this.dialogDelete = false
                await this.initialize()
            },

            addNewItem: function() {
                this.$router.push({ name: 'vehicle-fuels-create' })
            },

            editItem (item) {
                this.$router.push({ name: 'vehicle-fuels-edit', params: { id: item.id } })
            },
            openPaymentDialog(item, payment) {
                this.paymentDialog = true
                this.payment = payment
            },
            closePaymentDialog(value) {
                if(value instanceof Object) {
                    const itemIndex = this.items.findIndex(item => item.id === this.expanded[0].id)
                    if(itemIndex >= 0) {
                        const paymentIndex = this.items[itemIndex].payments.findIndex(payment => payment.id === value.id)
                        if(paymentIndex >= 0) {
                            this.items[itemIndex].payments.splice(paymentIndex, 1)
                            this.items[itemIndex].payments.push(value)
                        } else {
                            this.items[itemIndex].payments.push(value)
                        }
                    }
                }
                this.paymentDialog = false
                this.payment = undefined
            },
            openPaymentDeleteDialog(item, payment) {
                this.paymentDeleteDialog = true
                this.payment = payment
            },
            closePaymentDeleteDialog(value) {
                if(value === true) {
                    const itemIndex = this.items.findIndex(item => item.id === this.expanded[0].id)
                    if(itemIndex >= 0) {
                        const paymentIndex = this.items[itemIndex].payments.findIndex(payment => payment.id === this.payment.id)
                        if(paymentIndex >= 0) {
                            this.items[itemIndex].payments.splice(paymentIndex, 1)
                        }
                    }
                }
                this.paymentDeleteDialog = false
                this.payment = undefined
            }
        },
    };
</script>
